import React, { useRef, useEffect, useState, memo } from "react";
import styled from "styled-components/macro";
import { useDispatch, useSelector } from "react-redux";
import { setAppBackdrop } from "features/appBackdrop/appBackdropSlice";
import { zIndexes } from "theme/Theme";
import DrawerNavExpandable from "./DrawerNavExpandable";
import DrawerMenuItem from "./DrawerMenuItem";
import { selectMenuItems } from "features/header/headerSlice";
import { MenuItem } from "features/header/types";
import { useLocation } from "react-router-dom";
import { upperMenus } from "components/AppHeader/Desktop/TopSection";
import DrawerNav from "./DrawerNav";
/* eslint-disable */

interface DrawerProps {
  isToggled: boolean;
  onClickOutside: () => void;
}

const Drawer: React.FC<DrawerProps> = ({ isToggled, onClickOutside }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const location = useLocation();

  const [activeId, setActiveId] = useState<number>(0);
  const menuItems = useSelector(selectMenuItems);

  useEffect(() => {
    onClickOutside();
  }, [location]);

  useEffect(() => {
    dispatch(setAppBackdrop(isToggled));
    return () => {
      setActiveId(0);
    };
  }, [isToggled, dispatch]);

  return (
    <>
      <DrawerContainer isToggled={isToggled} ref={containerRef}>
        {isToggled && (
          <DrawerSection>
            {menuItems.length !== 0 &&
              menuItems.map((menu: MenuItem, idx) => {
                if (menu.data.length === 0) {
                  return (
                    <DrawerNav
                      key={idx}
                      item={menu}
                      containerRef={containerRef}
                    />
                  );
                } else {
                  return (
                    <DrawerNavExpandable
                      key={idx}
                      isExpanded={menu.id === activeId}
                      data={menu}
                      setExpandable={setActiveId}
                      containerRef={containerRef}
                    >
                      {menu.data.map((item, idx: number) => {
                        return (
                          <DrawerMenuItem
                            key={idx}
                            item={item}
                            delay={idx * 0.05}
                            isBrand={menu.name === "brand"}
                          />
                        );
                      })}
                    </DrawerNavExpandable>
                  );
                }
              })}
            {upperMenus.map((menu, idx) => {
              return (
                <DrawerNav key={idx} item={menu} containerRef={containerRef} />
              );
            })}
          </DrawerSection>
        )}
      </DrawerContainer>
      {isToggled && <DrawerOverlay onClick={onClickOutside} />}
    </>
  );
};
const DrawerContainer = styled.div<{ isToggled: boolean }>`
  z-index: ${zIndexes.drawer};
  position: absolute;
  width: 80%;
  max-width: 350px;
  max-height: inherit;
  height: calc(100vh - 3.125rem);
  height: calc(100dvh - 3.125rem);
  background-color: #eeeeee;
  -webkit-font-smoothing: antialiased;
  transform-origin: 0% 0%;
  transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1);
  transform: ${(props: any) =>
    props.isToggled === true ? "none" : "translate(-100%, 0)"};
  overflow: auto;
`;

const DrawerSection = styled.section`
  flex-direction: column;
  justify-content: flex-start;
  flex: 1 1 auto;
  overflow: hidden;
  background-color: #eeeeee;
  &:last-child {
    margin-bottom: 0;
  }
`;

const DrawerOverlay = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: ${zIndexes.backdrop};
  background-color: rgba(0, 0, 0, 0.45);
`;

export default memo(Drawer);
